import { type InputHTMLAttributes, forwardRef } from 'react';
import clsx from 'clsx';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  prefix?: string;
  suffix?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, prefix, suffix, className, ...props }, ref) => {
    return (
      <div className="flex items-center gap-2.5">
        {label && (
          <span className="text-sm text-text-muted font-mono w-36 shrink-0">{label}</span>
        )}
        <div className="relative flex-1">
          {prefix && (
            <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-text-dim font-mono text-sm">
              {prefix}
            </span>
          )}
          <input
            ref={ref}
            className={clsx(
              'w-full py-3.5 px-4 bg-input-bg border border-input-border rounded-[3px]',
              'text-text-bright text-md font-mono outline-none',
              'focus:border-accent/20',
              prefix && 'pl-6',
              className,
            )}
            {...props}
          />
        </div>
        {suffix && (
          <span className="text-text-dim font-mono text-sm shrink-0">{suffix}</span>
        )}
      </div>
    );
  },
);
Input.displayName = 'Input';
